import { render, staticRenderFns } from "./Publipostages.vue?vue&type=template&id=ad4c8824&"
import script from "./Publipostages.vue?vue&type=script&lang=js&"
export * from "./Publipostages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports